import { render, staticRenderFns } from "./Limits.vue?vue&type=template&id=00d931c1&"
import script from "./Limits.vue?vue&type=script&lang=js&"
export * from "./Limits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports